export function clearJwtHpCookie(): void {
  document.cookie = 'jwt_hp=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=.h2h.tech;';
  document.cookie = 'jwt_hp=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=.proconnect.loreal.pl;';
}
